<template>
  <div class="flow-steps">
    <flow-step v-for="(step, index) in steps" :key="step.name" :step="step" :number="index + 1"></flow-step>
  </div>
</template>

<script>
import FlowStep from './FlowStep.vue';
export default {
  name: 'flow-steps',
  components: {FlowStep},
  data() {
    return {};
  },
  props: {
    steps: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/web/_variables.scss';

.flow-steps {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  min-height: 100px;
  background: #ffffff;

  @media (max-width: $breakpoint-sm) {
    flex-wrap: wrap;
  }
}
</style>
